import React from "react";

const Sidebar = ({ groupedRooms, expandedGroups, onToggleGroup }) => {
  return (
    <div className="sidebar-content">
      {groupedRooms.map(([type, groupRooms]) => (
        <div key={type}>
          {/* Group Header */}
          <div
            className="d-flex align-items-center px-3 border-bottom cursor-pointer"
            style={{
              height: "40px",
              backgroundColor: "#ffe4e6",
              cursor: "pointer",
            }}
            onClick={() => onToggleGroup(type)}
          >
            <span className="me-2">{expandedGroups.has(type) ? "−" : "+"}</span>
            <span className="small">{type}</span>
          </div>

          {/* Rooms */}
          {expandedGroups.has(type) &&
            groupRooms.map((room) => (
              <div
                key={room.id}
                className="d-flex align-items-center px-3 border-bottom"
                style={{ height: "35px" }}
              >
                <div style={{ fontSize: "smaller" }}>{room.room_number}</div>
                <div className="ms-auto text-muted small">🛏️</div>
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
